const apiPath = 'https://ferryopsstageapinwt.topasexplorergroup.com'; 

const config = {
    apiPath,
  };
  
  export default config;